import React, { Component } from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { MuiThemeProvider as MuiThemeProviderV4, createMuiTheme } from '@material-ui/core/styles';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import purple from '@material-ui/core/colors/purple';
import Main from './containers/Main';
import Login from './containers/Login';
import { verifyToken } from './redux/actions/AuthActions';
import { checkIfUserIsAuthenticated, checkIfAppIsCurrentlyVerifyingUser } from './redux/reducers';

// Loader is a dummy component to inform the user,
// that the app is currently loading something.
// Could & should be enhanced visually
const Loader = ({ content }) => (<span>{content}</span>);


const theme = createMuiTheme({
  palette: {
    primary: { main: '#8080be' },
    secondary: { main: purple[500] },
  },
});

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#8080be',
  },
});

class App extends Component {
  componentDidMount() {
    // If there is a key named 'cadess-ui-token' in local storage,
    // make an API call to our server to verify it
    if (localStorage.getItem('cadess-ui-token') !== null) {
      this.props.dispatch(verifyToken());
    }
  }

  viewToDisplay = (userIsAuthenticated) =>
    (userIsAuthenticated ? <Main /> : <Login />);

  render() {
    const {
      waitingForAuthentication,
      userIsAuthenticated,
    } = this.props;

    return (
      <MuiThemeProviderV4 theme={theme}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <div>
            {
              waitingForAuthentication ?
                (<Loader content="verifying credentials..." />)
                :
                (this.viewToDisplay(userIsAuthenticated))
            }
          </div>
        </MuiThemeProvider>
      </MuiThemeProviderV4>
    );
  }
}

const mapStateToProps = (state) => ({
  waitingForAuthentication: checkIfAppIsCurrentlyVerifyingUser(state),
  userIsAuthenticated: checkIfUserIsAuthenticated(state),
});

export default connect(mapStateToProps)(App);
